type Copy = (text: string) => void;

/**
 * Копирует переданную строку в буфер обмена
 */
const copy: Copy = (text) => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

export default copy;
